var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsContentCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 19.5h15V8.874h-15V19.5zm15-15H17V3.249a1.25 1.25 0 00-2.5 0V4.5h-5V3.249a1.25 1.25 0 00-2.5 0V4.5H4.5A2.5 2.5 0 002 7v12.5A2.5 2.5 0 004.5 22h15a2.5 2.5 0 002.5-2.5V7a2.5 2.5 0 00-2.5-2.5z",
    fill: "red"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjUgMTkuNUgxOS41VjguODc0NUg0LjVWMTkuNVpNMTkuNSA0LjVIMTdWMy4yNDg5OUMxNyAyLjU1ODkyIDE2LjQ0MTEgMiAxNS43NDkgMkMxNS4wNjA5IDIgMTQuNSAyLjU1ODkyIDE0LjUgMy4yNDg5OVY0LjVIOS41VjMuMjQ4OTlDOS41IDIuNTU4OTIgOC45MzkwNiAyIDguMjUxMDEgMkM3LjU1ODkyIDIgNyAyLjU1ODkyIDcgMy4yNDg5OVY0LjVINC41QzMuMTE5ODUgNC41IDIgNS42MTk4NSAyIDdWMTkuNUMyIDIwLjg4MDEgMy4xMTk4NSAyMiA0LjUgMjJIMTkuNUMyMC44ODAxIDIyIDIyIDIwLjg4MDEgMjIgMTkuNVY3QzIyIDUuNjE5ODUgMjAuODgwMSA0LjUgMTkuNSA0LjVaIiBmaWxsPSJyZWQiLz4KPC9zdmc+Cg==";
export { SvgIconsContentCalendar as ReactComponent };